import {
  Autocomplete,
  Box,
  Button,
  CircularProgress,
  Container,
  Divider,
  Grid2,
  Paper,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { toast, ToastContainer } from "react-toastify";

const CashDeposit = () => {
  const [discoverLoading, setDiscoverLoading] = useState(false);
  const [captureLoading, setCaptureLoading] = useState(false);
  const [deviceDiscovered, setDeviceDiscovered] = useState(false);
  const finalUrlRef = useRef(null);
  const [serviceType, setServiceType] = useState("CD"); // Default selection
  const [location, setLocation] = useState({ latitude: null, longitude: null });
  const [cdEnabled, setCDEnabled] = useState(false);
  const [bankList, setBankList] = useState([]);
  const [formData, setFormData] = useState({
    mobileNumber: "",
    transactionAmount: "",
    adhaarNumber: "",
    bank: "",
    nationalBankIdentificationNumber: null, // Stores selected value
  });

  const discoverAvdm = async () => {
    setDiscoverLoading(true);
    let successFlag = false;
    let primaryUrl =
      window.location.protocol === "https:"
        ? "https://127.0.0.1:"
        : "http://127.0.0.1:";

    for (let i = 11100; i <= 11120; i++) {
      try {
        const response = await fetch(primaryUrl + i, {
          method: "RDSERVICE",
          mode: "cors",
          headers: { "Content-Type": "text/xml; charset=utf-8" },
        });

        if (!response.ok) continue;
        const data = await response.text();
        if (data.includes("Mantra")) {
          finalUrlRef.current = primaryUrl + i;
          successFlag = true;
          break;
        }
      } catch (error) {
        console.error("Error discovering AVDM:", error);
      }
    }

    setDiscoverLoading(false);
    if (successFlag) {
      setDeviceDiscovered(true);
      toast.success("Device discovered successfully!");
    } else {
      toast.error("Device discovery failed. Please try again.");
    }
  };

  const captureAvdm = async () => {
    // Validate formData before proceeding
    console.log(formData);
    if (
      !formData.mobileNumber.trim() ||
      !formData.transactionAmount.trim() ||
      !formData.adhaarNumber.trim() ||
      !formData.bank.bankName.trim()
    ) {
      toast.error("Error: Form data is missing.");
      return;
    }
    setDiscoverLoading(true);
    setCaptureLoading(true);
    if (!finalUrlRef.current) {
      alert("Please discover AVDM first.");
      return;
    }

    const captureUrl = `${finalUrlRef.current}/rd/capture`;

    const XML = `<?xml version="1.0"?>
              <PidOptions ver="1.0">
                  <Opts fCount="1" fType="2" iCount="0" pCount="0" format="0" pidVer="2.0"  timeout="10000"  posh="UNKNOWN" env="P" />
                  <CustOpts>
                      <Param name="mantrakey" value="SOME_KEY_VALUE" />
                  </CustOpts>
              </PidOptions>`;

    try {
      const response = await fetch(captureUrl, {
        method: "CAPTURE",
        headers: {
          "Content-Type": "text/xml; charset=utf-8",
        },
        body: XML,
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.text();

      const parser = new DOMParser();
      const xmlDoc = parser.parseFromString(data, "text/xml");

      const resp = xmlDoc.getElementsByTagName("Resp")[0];
      const errInfo = resp.getAttribute("errInfo");

      const deviceInfo = xmlDoc.getElementsByTagName("DeviceInfo")[0];
      const additionalInfo =
        deviceInfo.getElementsByTagName("additional_info")[0];
      const skey = xmlDoc.getElementsByTagName("Skey")[0];
      const pidDataElement = xmlDoc.getElementsByTagName("Data")[0];

      const skeydata = skey.textContent;
      const ci = skey.getAttribute("ci");
      const piddata = pidDataElement.textContent;
      const pidtype = pidDataElement.getAttribute("type");

      const parameters = [];
      const params = additionalInfo.getElementsByTagName("Param");
      for (let i = 0; i < params.length; i++) {
        parameters.push({
          name: params[i].getAttribute("name"),
          value: params[i].getAttribute("value"),
        });
      }

      const extractedData = {
        resp: {
          errCode: resp.getAttribute("errCode"),
          errInfo: errInfo,
          fCount: resp.getAttribute("fCount"),
          fType: resp.getAttribute("fType"),
          nmPoints: resp.getAttribute("nmPoints"),
          qScore: resp.getAttribute("qScore"),
        },
        deviceInfo: {
          dpId: deviceInfo.getAttribute("dpId"),
          rdsId: deviceInfo.getAttribute("rdsId"),
          rdsVer: deviceInfo.getAttribute("rdsVer"),
          mi: deviceInfo.getAttribute("mi"),
          mc: deviceInfo.getAttribute("mc"),
          dc: deviceInfo.getAttribute("dc"),
        },
        additionalInfo: parameters,
        ci: ci,
        skeydata: skeydata,
        hmac: xmlDoc.getElementsByTagName("Hmac")[0].textContent,
        piddata: piddata,
        pidtype: pidtype,
      };

      if (errInfo === "Success.") {
        // Combine extractedData with tfaData
        const combinedPayload = {
          ...extractedData,
          nationalBankIdentificationNumber:
            formData.nationalBankIdentificationNumber,
          adhaarNumber: formData.adhaarNumber,
          transactionAmount: formData.transactionAmount,
          mobileNumber: formData.mobileNumber,
        };

        // console.log(combinedPayload);
        // Call the /tfa API with the combined payload
        // await call2faApi(combinedPayload);
        await dataBaseChange(combinedPayload);
      } else {
        setDiscoverLoading(false);
        setCaptureLoading(false);
        toast.error(`Capture failed: ${errInfo}`);
      }
    } catch (error) {
      setDiscoverLoading(false);
      setCaptureLoading(false);
      console.error("Error capturing data:", error);
      alert("Failed to capture data. Please try again.");
    }
  };

  const dataBaseChange = async (payload) => {
    try {
      const token = sessionStorage.getItem("jwtToken");
      if (!token) {
        toast.error("Authentication token missing.");
        return;
      }

      const response = await fetch(
        "https://api.ipaisa.co.in/myapp/auth/cms/cash_deposit",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(payload),
        }
      );

      if (!response.ok) {
        throw new Error(`Error: ${response.status} - ${response.statusText}`);
      }

      const data = await response.json();
      console.log("Deposit Data:", data);
      toast.info(data?.body?.message || "Something went wrong..!!");
      setDiscoverLoading(false);
      setCaptureLoading(false);
    } catch (e) {
      setDiscoverLoading(false);
      setCaptureLoading(false);
    }
  };

  const check2FA = async () => {
    try {
      const token = sessionStorage.getItem("jwtToken");
      if (!token) {
        toast.error("Authentication token missing.");
        return;
      }

      const response = await fetch(
        "https://api.ipaisa.co.in/myapp/auth/cms/verifyMerchantStatus",
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error(`Error: ${response.status} - ${response.statusText}`);
      }
      const data = await response.json();
      // console.log("2FA API Data:", data);
      if (data.body?.cashDepositTFA === "TRUE") {
        // toast.success("2FA Active");
        // console.log("auksdh");
        setCDEnabled(true);
        const response = await fetch(
          "https://api.ipaisa.co.in/myapp/auth/cms/cashDepositBankList",
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const data = await response.json();
        // console.log("list", data);
        setBankList(data.body?.data || []);
      } else {
        // console.log("][][plilk");
        toast.error("2FA Not Active");
        setCDEnabled(false);
      }
    } catch (e) {}
  };

  // Handler for text fields
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Handler for Autocomplete (Ensures Single Selection)
  const handleBankChange = (_, selectedBank) => {
    setFormData((prev) => ({
      ...prev,
      bank: selectedBank || null, // Store the object or null if cleared
      nationalBankIdentificationNumber: selectedBank?.iinno || "", // Safe access
    }));
  };

  useEffect(() => {
    check2FA();
  }, []);

  return (
    <div>
      <Box style={{ padding: "2rem", marginTop: "calc(3% + 56px)" }}>
        <Paper elevation={4} sx={{ padding: 2 }}>
          <Typography variant="h2">Cash Deposit</Typography>
          {!cdEnabled && (
            <Stack direction="row" justifyContent="center">
              <Typography variant="h5" color="error">
                ** Please do the 2-Factor Authentication for Cash Deposit/CD{" "}
              </Typography>
            </Stack>
          )}

          <Grid2 container spacing={2}>
            {/* Aadhar Number */}
            <Grid2 size={{ xs: 12, md: 6 }}>
              <Typography>Enter Aadhar Number</Typography>
              <TextField
                fullWidth
                label="Aadhar Number"
                name="adhaarNumber"
                value={formData.adhaarNumber}
                onChange={handleChange}
                inputProps={{ maxLength: 12 }} // Ensures only 12 digits
                disabled={!cdEnabled}
              />
            </Grid2>

            {/* Mobile Number */}
            <Grid2 size={{ xs: 12, md: 6 }}>
              <Typography>Enter Mobile Number (Aadhar Linked)</Typography>
              <TextField
                fullWidth
                label="Mobile Number"
                name="mobileNumber"
                value={formData.mobileNumber}
                onChange={handleChange}
                inputProps={{ maxLength: 10 }} // Ensures only 10 digits
                disabled={!cdEnabled}
              />
            </Grid2>

            {/* Transaction Amount */}
            <Grid2 size={{ xs: 12, md: 6 }}>
              <Typography>Enter Amount</Typography>
              <TextField
                fullWidth
                label="Amount"
                name="transactionAmount"
                type="number"
                value={formData.transactionAmount}
                onChange={handleChange}
                disabled={!cdEnabled}
              />
            </Grid2>

            {/* Bank Selection */}
            <Grid2 size={{ xs: 12, md: 6 }}>
              <Typography>Please select bank</Typography>
              <Autocomplete
                fullWidth
                options={bankList}
                getOptionLabel={(option) => option?.bankName || ""}
                value={formData.bank}
                onChange={handleBankChange}
                disabled={!cdEnabled}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select Bank"
                    variant="outlined"
                    fullWidth
                  />
                )}
              />
            </Grid2>
          </Grid2>
          <Divider sx={{ marginTop: 1, marginBottom: 1 }} />
          <Stack spacing={2} direction="row" justifyContent="center">
            <Button
              variant="contained"
              onClick={discoverAvdm}
              disabled={!cdEnabled}
            >
              {discoverLoading ? <CircularProgress size={24} /> : "Discover"}
            </Button>

            <Button
              variant="contained"
              onClick={captureAvdm}
              disabled={!deviceDiscovered || captureLoading}
            >
              {captureLoading ? (
                <CircularProgress size={24} />
              ) : (
                "Capture & DEPOSIT"
              )}
            </Button>
          </Stack>
        </Paper>
      </Box>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss={false}
        draggable
        pauseOnHover
        theme="colored"
      />
    </div>
  );
};

export default CashDeposit;
